<div class="breadcrumb-container">
  <div class="inner">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
          <li
            *ngIf="!breadcrumb.active"
            class="breadcrumb-item"
            dropdown
            [routerLinkActive]="['active']"
          >
            <a
              [routerLink]="[breadcrumb.url]"
              routerLinkActive="active"
              [tooltip]="breadcrumb.tooltip ? tooltipTemplate : ''"
              placement="bottom"
              *ngIf="breadcrumbs.length !== i + 1"
              >{{ breadcrumb.label }}</a
            >
            <span class="bc-active" *ngIf="breadcrumbs.length === i + 1">{{
              breadcrumb.label
            }}</span>
            <ng-template #tooltipTemplate>
              <div
                class="dropdown-breadcrumb"
                [innerHTML]="breadcrumb.tooltip"
              ></div>
            </ng-template>
          </li>
          <li *ngIf="breadcrumb.active">
            {{ breadcrumb.label }}
          </li>
        </ng-container>
      </ol>
    </nav>
  </div>
</div>
